(() => {
  const containerSelector = '.grid-product__colors';
  const swatchSelector = ':scope > .color-swatch';
  const maxVisible = 4;

  const swatchColors = {
    black: '#111111', white: '#ffffff', red: '#b32025', pink: '#f4a3b7',
    blue: '#2467b2', green: '#3f7d3d', yellow: '#f1c84b', orange: '#e98032',
    purple: '#7b4aa8', brown: '#795548', beige: '#d6c0a4', grey: '#8f8f8f',
    gray: '#8f8f8f', gold: '#c6a24a', champagne: '#d8b56a', ivory: '#d6c0a4',
    khaki: '#d6c0a4', silver: '#8f8f8f', navy: '#2467b2', olive: '#3f7d3d',
    lavender: '#7b4aa8', violet: '#7b4aa8', peach: '#f4a3b7', coral: '#e98032',
  };
  const exactColors = {
    apricot: '#f3b37a', burgundy: '#7b1e2b', chartreuse: '#a6c84c', coffee: '#795548',
    'light coffee': '#b58b62', golden: '#c6a24a', hotpink: '#f04f9b', mint: '#79c9b0',
    'navy blue': '#2467b2', 'olive green': '#657a3f', peacock: '#1f7f88', rose: '#d96d8a',
    turmeric: '#d5a028', turquoise: '#35aeb2', 'blue-gray': '#6d8493', 'gray blue': '#6d8493',
    'gray green': '#748c7b', 'light blue grey': '#8fa9ba', 'peach pink': '#f4a3b7',
    'blue stripe': '#2467b2', 'red plaid': '#b32025', 'pink dots': '#f4a3b7',
    'pink stripe': '#f4a3b7', 'dark blue': '#1d4f91', 'deep blue': '#1d4f91',
    'sky blue': '#68a9dd', 'lake blue': '#3f8ec5', 'light blue': '#68a9dd',
    'aqua green': '#3f9b89', 'army green': '#566b3d', 'bright green': '#55a65a',
    'celadon green': '#91b79b', 'dark green': '#245c3b', 'ice green': '#a7d8c8',
    'lake green': '#3f9074', 'light green': '#89c97b', 'mint green': '#79c9b0',
    'pale green': '#b7d88c', 'dark brown': '#4f3428', 'light brown': '#b88962',
    'dark gray': '#5f6468', 'dark pink': '#cc6f8e', 'light pink': '#f7bfd0',
    'pale pink': '#f7cbd3', 'rose pink': '#e889a0', 'dark red': '#8f2430',
    'deep red': '#8f2430', 'fire brick red': '#a83a3a', 'rose red': '#c94d63',
    'true red': '#d13438', 'wine red': '#7b1e2b', 'bright purple': '#8f5eb5',
    'deep purple': '#57367d', 'light yellow': '#f7dc75', 'midium yellow': '#efc94a',
    ivory: '#e9dfc8', khaki: '#b8a37b', silver: '#a9afb7',
  };
  const rainbow = 'conic-gradient(#d83b31, #efc04a, #4a8f45, #3478ba, #874eb5, #d83b31)';

  function applyColor(swatch) {
    const name = swatch.textContent.trim().toLowerCase();
    if (!name || swatch.dataset.dvColorApplied === name) return;
    swatch.dataset.dvColorApplied = name;
    if (name === 'white' || name === 'pure white' || name === 'off white') {
      swatch.style.setProperty('background', '#ffffff', 'important');
      return;
    }
    if (exactColors[name]) {
      swatch.style.setProperty('background', exactColors[name], 'important');
      return;
    }
    const words = name.replace(/[^a-z]+/g, ' ').trim().split(/\s+/).filter(Boolean);
    const recognized = [...new Set(words.filter((word) => swatchColors[word]))];
    const isComposite = /[&/+,]/.test(name) || /\b(rainbow|multi|multicolor|mixed|patchwork|gingerbread|cherry)\b/.test(name);
    if (isComposite || recognized.length > 1) {
      swatch.style.setProperty('background', rainbow, 'important');
      return;
    }
    const color = swatchColors[recognized[0]];
    if (color) swatch.style.setProperty('background', color, 'important');
    else swatch.style.setProperty('background', rainbow, 'important');
  }

  function fit(container) {
    if (!container.isConnected) return;
    container.querySelectorAll('.dv-swatch-more').forEach((node) => node.remove());
    const swatches = [...container.querySelectorAll(swatchSelector)];
    swatches.forEach((swatch) => { swatch.hidden = false; });
    if (swatches.length <= maxVisible) return;
    swatches.slice(maxVisible).forEach((swatch) => { swatch.hidden = true; });
    const more = document.createElement('span');
    more.className = 'dv-swatch-more';
    more.textContent = `+${swatches.length - maxVisible}`;
    more.setAttribute('aria-label', `${swatches.length - maxVisible} more colors`);
    container.append(more);
  }

  function apply(root = document) {
    root.querySelectorAll(containerSelector).forEach(fit);
    root.querySelectorAll('.color-swatch').forEach(applyColor);
  }

  let frame;
  function schedule() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => apply());
  }

  document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:select', schedule);
  document.addEventListener('shopify:section:deselect', schedule);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  schedule();
})();
